var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeSeriesPlot',{attrs:{"name":_vm.name,"data":_vm.data,"translation-path":_vm.translationPath,"initial-data":_vm.initialData,"visu-id":_vm.visuId,"refresh-rate":_vm.refreshRate,"plot-type":"bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }